export default __webpack_public_path__ + "images/0e8a64df1405efe3a39cd9c8e8984db7-dont_2.png";